// // app/javascript/controllers/clicker_controller.js
// import { Controller } from "@hotwired/stimulus"

// export default class extends Controller {
//   trigger(event) {
//     const triggerId = event.currentTarget.dataset.triggerid
//     const button = document.getElementById(triggerId)

//     if (button) {
//       button.click()
//     } else {
//       console.warn(`No element found with ID: ${triggerId}`)
//     }
//   }
// }


// app/javascript/controllers/clicker_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const triggerId = this.element.dataset.triggerid
    const button = document.getElementById(triggerId)

    if (button) {
      button.click()
    } else {
      console.warn(`No element found with ID: ${triggerId}`)
    }

    // cleanup so it doesn’t stay in DOM
    // this.element.remove()
  }

  trigger(event) {
    const triggerId = event.currentTarget.dataset.triggerid
    const button = document.getElementById(triggerId)

    if (button) {
      button.click()
    } else {
      console.warn(`No element found with ID: ${triggerId}`)
    }
  }
}
